import { useQuery } from "react-query";
import invitationAPI from "../invitationAPI";

export const useInvitationInfo = (token) => {
  return useQuery(
    ["invitation-info", token],
    () => invitationAPI.getInvitationInfo(token),
    {
      enabled: !!token,
      retry: false,
      staleTime: Infinity, // Invitation info doesn't change
    }
  );
};
